<p-dialog
  [(visible)]="visivel"
  [style]="{ width: '50rem', height: '80%' }"
  header="Perfil"
  [modal]="true"
  styleClass="p-fluid"
  (onHide)="escondeDialog()"
>
<ng-template pTemplate="content">
    <div class="field">
        <label for="nome">Nome do Perfil:</label>
        <input id="nome" pInputText type="text" [(ngModel)]="perfil.nomePerfil" required autofocus>
        <small class="p-error" *ngIf="perfilEnviado && !perfil.nomePerfil">Nome é obrigatório.</small>
    </div>
    <div class="field">
        <p-fieldset legend="Permissões">
            <p-tree 
            [value]="permissoes" 
            selectionMode="checkbox" 
            class="w-full md:w-30rem" 
            
            [(selection)]="permissoesSelecionadas" />
        </p-fieldset>
    </div>
</ng-template>
<ng-template pTemplate="footer">
    <button
      pButton
      label="Cancelar"
      icon="pi pi-times"
      class="p-button-text"
      (click)="escondeDialog()"
    ></button>
    <button
      pButton
      label="Salvar"
      icon="pi pi-check"
      class="p-button-text"
      (click)="salvar()"
    ></button>
</ng-template>
</p-dialog>
